import { combineReducers } from 'redux';

const templates = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_EMAIL_TEMPLATES_FULFILLED':
      return action.payload.data;
    case 'FETCH_EMAIL_TEMPLATES_REJECTED':
      return [];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_EMAIL_TEMPLATES_FULFILLED':
    case 'FETCH_EMAIL_TEMPLATES_REJECTED':
      return false;
    case 'FETCH_EMAIL_TEMPLATES_PENDING':
      return true;
    default:
      return state;
  }
};

const email = combineReducers({
  templates,
  isFetching,
});

export default email;
